<template>
  <div
    class="chat-predefined chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    <CancelItem
      v-if="message.data_predefined === 'cancel_element'"
      :reasons="cancelReasons"
      :token="token"
    >
    </CancelItem>
    <WhileWaiting v-if="message.data_predefined === 'while_waiting'">
    </WhileWaiting>
    <TransmitDocument v-if="message.data_predefined === 'transmit_document'">
    </TransmitDocument>
  </div>
</template>

<script>
import MessageDate from '../MessageDate.vue';
import { CancelItem, WhileWaiting, TransmitDocument } from '../Predefined';

export default {
  name: 'PredefinedItem',
  props: ['message', 'cancelReasons', 'token'],
  components: {
    MessageDate,
    CancelItem,
    WhileWaiting,
    TransmitDocument,
  },
};
</script>

<style></style>
